function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, computed, unref, openBlock, createElementBlock, normalizeClass, withModifiers, createElementVNode, normalizeStyle, createBlock, Transition, withCtx, withDirectives, createVNode, vShow, createCommentVNode, renderSlot, Fragment, renderList, toDisplayString } from 'vue';
import { ElIcon } from '../../icon/index.mjs';
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue';
import '../../../hooks/index.mjs';
import { carouselProps, carouselEmits } from './carousel.mjs';
import { useCarousel } from './use-carousel.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { useNamespace } from '../../../hooks/use-namespace/index.mjs';
const _hoisted_1 = ["onMouseenter", "onClick"];
const _hoisted_2 = {
  key: 0
};
const COMPONENT_NAME = "ElCarousel";
const __default__ = defineComponent({
  name: COMPONENT_NAME
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: carouselProps,
  emits: carouselEmits,
  setup(__props, _ref) {
    let expose = _ref.expose,
      emit = _ref.emit;
    const props = __props;
    const _useCarousel = useCarousel(props, emit, COMPONENT_NAME),
      root = _useCarousel.root,
      activeIndex = _useCarousel.activeIndex,
      arrowDisplay = _useCarousel.arrowDisplay,
      hasLabel = _useCarousel.hasLabel,
      hover = _useCarousel.hover,
      isCardType = _useCarousel.isCardType,
      items = _useCarousel.items,
      isVertical = _useCarousel.isVertical,
      containerStyle = _useCarousel.containerStyle,
      handleButtonEnter = _useCarousel.handleButtonEnter,
      handleButtonLeave = _useCarousel.handleButtonLeave,
      handleIndicatorClick = _useCarousel.handleIndicatorClick,
      handleMouseEnter = _useCarousel.handleMouseEnter,
      handleMouseLeave = _useCarousel.handleMouseLeave,
      setActiveItem = _useCarousel.setActiveItem,
      prev = _useCarousel.prev,
      next = _useCarousel.next,
      PlaceholderItem = _useCarousel.PlaceholderItem,
      isTwoLengthShow = _useCarousel.isTwoLengthShow,
      throttledArrowClick = _useCarousel.throttledArrowClick,
      throttledIndicatorHover = _useCarousel.throttledIndicatorHover;
    const ns = useNamespace("carousel");
    const carouselClasses = computed(() => {
      const classes = [ns.b(), ns.m(props.direction)];
      if (unref(isCardType)) {
        classes.push(ns.m("card"));
      }
      return classes;
    });
    const indicatorsClasses = computed(() => {
      const classes = [ns.e("indicators"), ns.em("indicators", props.direction)];
      if (unref(hasLabel)) {
        classes.push(ns.em("indicators", "labels"));
      }
      if (props.indicatorPosition === "outside") {
        classes.push(ns.em("indicators", "outside"));
      }
      if (unref(isVertical)) {
        classes.push(ns.em("indicators", "right"));
      }
      return classes;
    });
    expose({
      setActiveItem,
      prev,
      next
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "root",
        ref: root,
        class: normalizeClass(unref(carouselClasses)),
        onMouseenter: _cache[6] || (_cache[6] = withModifiers(function () {
          return unref(handleMouseEnter) && unref(handleMouseEnter)(...arguments);
        }, ["stop"])),
        onMouseleave: _cache[7] || (_cache[7] = withModifiers(function () {
          return unref(handleMouseLeave) && unref(handleMouseLeave)(...arguments);
        }, ["stop"]))
      }, [createElementVNode("div", {
        class: normalizeClass(unref(ns).e("container")),
        style: normalizeStyle(unref(containerStyle))
      }, [unref(arrowDisplay) ? (openBlock(), createBlock(Transition, {
        key: 0,
        name: "carousel-arrow-left",
        persisted: ""
      }, {
        default: withCtx(() => [withDirectives(createElementVNode("button", {
          type: "button",
          class: normalizeClass([unref(ns).e("arrow"), unref(ns).em("arrow", "left")]),
          onMouseenter: _cache[0] || (_cache[0] = $event => unref(handleButtonEnter)("left")),
          onMouseleave: _cache[1] || (_cache[1] = function () {
            return unref(handleButtonLeave) && unref(handleButtonLeave)(...arguments);
          }),
          onClick: _cache[2] || (_cache[2] = withModifiers($event => unref(throttledArrowClick)(unref(activeIndex) - 1), ["stop"]))
        }, [createVNode(unref(ElIcon), null, {
          default: withCtx(() => [createVNode(unref(ArrowLeft))]),
          _: 1
        })], 34), [[vShow, (_ctx.arrow === "always" || unref(hover)) && (props.loop || unref(activeIndex) > 0)]])]),
        _: 1
      })) : createCommentVNode("v-if", true), unref(arrowDisplay) ? (openBlock(), createBlock(Transition, {
        key: 1,
        name: "carousel-arrow-right",
        persisted: ""
      }, {
        default: withCtx(() => [withDirectives(createElementVNode("button", {
          type: "button",
          class: normalizeClass([unref(ns).e("arrow"), unref(ns).em("arrow", "right")]),
          onMouseenter: _cache[3] || (_cache[3] = $event => unref(handleButtonEnter)("right")),
          onMouseleave: _cache[4] || (_cache[4] = function () {
            return unref(handleButtonLeave) && unref(handleButtonLeave)(...arguments);
          }),
          onClick: _cache[5] || (_cache[5] = withModifiers($event => unref(throttledArrowClick)(unref(activeIndex) + 1), ["stop"]))
        }, [createVNode(unref(ElIcon), null, {
          default: withCtx(() => [createVNode(unref(ArrowRight))]),
          _: 1
        })], 34), [[vShow, (_ctx.arrow === "always" || unref(hover)) && (props.loop || unref(activeIndex) < unref(items).length - 1)]])]),
        _: 1
      })) : createCommentVNode("v-if", true), createVNode(unref(PlaceholderItem)), renderSlot(_ctx.$slots, "default")], 6), _ctx.indicatorPosition !== "none" ? (openBlock(), createElementBlock("ul", {
        key: 0,
        class: normalizeClass(unref(indicatorsClasses))
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(unref(items), (item, index) => {
        return withDirectives((openBlock(), createElementBlock("li", {
          key: index,
          class: normalizeClass([unref(ns).e("indicator"), unref(ns).em("indicator", _ctx.direction), unref(ns).is("active", index === unref(activeIndex))]),
          onMouseenter: $event => unref(throttledIndicatorHover)(index),
          onClick: withModifiers($event => unref(handleIndicatorClick)(index), ["stop"])
        }, [createElementVNode("button", {
          class: normalizeClass(unref(ns).e("button"))
        }, [unref(hasLabel) ? (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(item.props.label), 1)) : createCommentVNode("v-if", true)], 2)], 42, _hoisted_1)), [[vShow, unref(isTwoLengthShow)(index)]]);
      }), 128))], 2)) : createCommentVNode("v-if", true)], 34);
    };
  }
}));
var Carousel = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "carousel.vue"]]);
export { Carousel as default };